import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Menu } from "@mui/material";
import React from "react";

import { IKitComponentInput } from "@/interfaces/kit.interface";
import { KitTableMessages } from "@/messages/products/kit-table.messages";
import NotificationItem from "@/mui/Items/NotificationItem";

interface Props {
  isOpen: boolean;
  anchorEl: (EventTarget & HTMLButtonElement) | null;
  onClose: () => void;
  messages: KitTableMessages;
  selectedKit: IKitComponentInput;
  onEdit: (kit: IKitComponentInput) => void;
  onRemove: (kit: IKitComponentInput) => void;
}

export function KitPopover({
  isOpen,
  anchorEl,
  onClose,
  messages,
  selectedKit,
  onEdit,
  onRemove,
}: Props) {
  return (
    <Menu
      open={isOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
    >
      <NotificationItem
        icon={<EditIcon />}
        title={messages.updatePopover}
        onClick={() => {
          onEdit(selectedKit);
          onClose();
        }}
      />

      <NotificationItem
        icon={<DeleteIcon />}
        title={messages.removePopover}
        onClick={() => {
          onRemove(selectedKit);
          onClose();
        }}
      />
    </Menu>
  );
}
